import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from "@mui/material";

const UrlModal = ({ open, onClose, gurlid, serviceName }) => {
    const shareUrl = `https://payments.invtechnologies.in/paynow/${gurlid}`;
    const message = `Dear Sir, Your bill for INV Service of ${serviceName} is here. You can pay through the link: ${shareUrl}`;
    const [displayMesg, setdisplayMesg] = useState("");

    const onCopy = () => {
        navigator.clipboard.writeText(message) 
            .then(() => {
                setdisplayMesg('Content copied to clipboard!');
            })
            .catch((error) => {
                setdisplayMesg('Failed to copy Content');
            });
    };

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: 'Payment',
                text: message,
                url: shareUrl,
            }).catch((error) => console.log('Error sharing', error));
        } else {
            // Fallback for browsers that do not support the Web Share API5
            const shareOptions = [
                { name: 'WhatsApp', url: `https://wa.me/?text=${encodeURIComponent(message)}` },
                { name: 'SMS', url: `sms:?body=${encodeURIComponent(message)}` },
                { name: 'Copy to Clipboard', action: () => navigator.clipboard.writeText(message) },
            ];

            // Display share options (this can be a modal or a simple alert for demonstration)
            const optionNames = shareOptions.map(option => option.name).join('\n');
            const selectedOption = prompt(`Choose an option:\n${optionNames}`);

            const selected = shareOptions.find(option => option.name === selectedOption);
            if (selected) {
                if (selected.url) {
                    window.open(selected.url, '_blank');
                } else if (selected.action) {
                    selected.action();
                }
            }
        }
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                    <IconButton sx={{ color: "red", width: '2.5rem' }} onClick={onClose}>x</IconButton>
                </Box>
                <h3 style={{ textAlign: "center" }}>Share/Copy the URL</h3>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "auto" }}>
                    <h2>Below is the Sharable message</h2>
                    <Box p={1} />
                    <Typography>{message}</Typography>
                    {displayMesg && (
                    <Typography color="success" sx={{ fontSize: "0.875rem", mt: 1 }}>
                        {displayMesg}
                    </Typography>
                )}
                </Box>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ display: "flex", justifyContent: "center", }}>
                <Button variant="outlined" onClick={() => onCopy()} sx={{
                        fontSize: { xs: '0.7rem', sm: '1rem' },
                        width: '45%',
                        fontWeight: "bold",
                        borderRadius: "20px",
                    }}>Copy</Button>
                <Button
                    variant='contained'
                    color='success'
                    onClick={() => handleShare()}
                    sx={{
                        fontSize: { xs: '0.7rem', sm: '1rem' },
                        width: '45%',
                        borderColor: "black",
                        fontWeight: "bold",
                        borderRadius: "20px",
                    }}
                >Share</Button>
            </DialogActions>
            <Box p={1} />
        </Dialog>
    );
};

export default UrlModal;
